import ProposalModal from './ProposalModal'

export default ProposalModal
